import type { ReactElement, SelectHTMLAttributes } from 'react';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export function Select({
  className,
  invalid,
  'aria-invalid': ariaInvalid,
  children,
  ...props
}: SelectProps): ReactElement {
  return (
    <select
      {...props}
      className={['cards-kit-select', className].filter(Boolean).join(' ')}
      aria-invalid={invalid ?? ariaInvalid}
      data-invalid={invalid === true ? 'true' : undefined}
    >
      {children}
    </select>
  );
}
